import { render } from "./SelectDayPage.vue?vue&type=template&id=6ab70ca9&scoped=true&ts=true"
import script from "./SelectDayPage.vue?vue&type=script&lang=ts"
export * from "./SelectDayPage.vue?vue&type=script&lang=ts"

import "./SelectDayPage.vue?vue&type=style&index=0&id=6ab70ca9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ab70ca9"]])

export default __exports__